module.exports = __webpack_public_path__ + "img/3.a4a7cc9a.jpg";